import React from 'react';
import styles from './ImageForHorizon.module.css'
import ImageWithBlurHash from "../ImageWithBlurhash/ImageWithBlurhash";


interface IProps {
    src: string,
    alt?: string,
    blurhash: string
}

const ImageForHorizon = ({src, alt = 'Фоновая картинка', blurhash}: IProps) => {
    // return <img className={styles.image} src={src} alt={alt}/>

    return <ImageWithBlurHash width={'none'} height={'none'} src={src}
                              hash={blurhash}
                              classNameBlurHash={styles.image}/>


        };

export default ImageForHorizon;